import React from "react";
import { Box } from "@mui/material";
import { getPageShellSx } from "../cmms/assetHierarchyStyles";
import ToolsPanel from "./components/ToolsPanel";

/*
 * The tool register, inside the maintenance module.
 *
 * The same tools the settings page lists, read from the same endpoint — this does not move them
 * and does not fork the register. What it adds is everything the service side already knows and
 * had nowhere to say: how far each tool has run against its schedule, in hours *and* in cycles,
 * which schedules watch it, and what has been serviced on it before.
 *
 * Read-only. A tool is created and edited under Settings → Tools, which is Role_Superuser; this
 * page is Cmms_Field, because the technician who performs the service is exactly who needs to
 * read it and exactly who that route excludes.
 */
export default function CmmsTools() {
  return (
    <Box sx={getPageShellSx()}>
      <ToolsPanel />
    </Box>
  );
}
